"use client";
import { useState } from "react";

import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownTrigger,
} from "@nextui-org/react";
import { useTranslations } from "next-intl";

import IconActive from "@/icons/ui/buttons/activeBtn.svg";
import { useCountryStore } from "@/store/country.store";
import { cn } from "@/utils/cn";

import styles from "./style.module.scss";

/* eslint-disable-next-line @typescript-eslint/no-empty-object-type */
interface Props extends React.HTMLAttributes<HTMLDivElement> {
  isWhite?: boolean;
  isWhiteBorder?: boolean;
}

export const Location = ({ className, isWhite, isWhiteBorder }: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const tCountry = useTranslations("countries");

  const { country, countryList } = useCountryStore();

  return (
    <Dropdown onOpenChange={setIsOpen}>
      <DropdownTrigger>
        <div
          className={cn(
            styles.button,
            isOpen && styles.open,
            className,
            isWhite && "!bg-transparent !border-white",
            isWhiteBorder && "!border-white",
          )}
        >
          {country.icon && (
            <country.icon
              className={styles.icon}
              width={24}
              height={24}
              aria-hidden="true"
            />
          )}
          <span className={cn(styles?.label, isWhite && "text-white")}>
            {tCountry(country.label)}
          </span>
        </div>
      </DropdownTrigger>
      <DropdownMenu
        aria-label="Country selection"
        className={styles?.list}
      >
        {countryList.map((item) => (
          <DropdownItem
            key={item.value}
            value={item.value}
            rel="nofollow"
            href={item.code !== country.code ? item.link : undefined}
            className={
              "p-[1.5rem] rounded-none [&:not(:last-child)]:border-b border-solid border-gray"
            }
            endContent={
              item.code === country.code && (
                <IconActive
                  className={"w-[1.8rem] h-[1.8rem]"}
                  aria-hidden="true"
                />
              )
            }
          >
            <span className={"flex items-center gap-[1rem]"}>
              {item.icon && (
                <item.icon
                  className={styles.icon}
                  width={24}
                  height={24}
                  aria-hidden="true"
                />
              )}
              <span className={styles.label}>{tCountry(item.label)}</span>
            </span>
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
};
